module.exports = __webpack_public_path__ + "img/hero-image-01-fi.637cbeb0.png";